import React, { useState } from "react";
import rightArrowIcon from "../Assets/Icons/arrow-right.png";
import closeIcon from "../Assets/Icons/close.png";

/**
 * Truncate HTML string by visible character count without breaking tags.
 * Appends "... Read more" inline.
 */
function truncateHtmlPreserveTags(html, maxChars) {
    const container = document.createElement("div");
    container.innerHTML = html;

    let charCount = 0;
    let reachedLimit = false;

    function traverse(node) {
        if (reachedLimit) return null;

        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent || "";
            if (charCount + text.length <= maxChars) {
                charCount += text.length;
                return document.createTextNode(text);
            } else {
                const slice = text.slice(0, maxChars - charCount).trimEnd();
                charCount = maxChars;
                reachedLimit = true;

                // Append inline span to this exact spot, preserving line
                const wrapper = document.createElement("span");
                wrapper.appendChild(document.createTextNode(slice));

                const ellipsis = document.createElement("span");
                ellipsis.textContent = "… ";
                wrapper.appendChild(ellipsis);

                const readMore = document.createElement("span");
                readMore.className = "read-more-inline";
                readMore.textContent = "Read more";
                readMore.setAttribute("data-readmore", "true"); // uniquely target
                wrapper.appendChild(readMore);

                return wrapper;
            }
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
            const clone = document.createElement(node.nodeName);

            for (let attr of node.attributes) {
                clone.setAttribute(attr.name, attr.value);
            }

            for (let child of node.childNodes) {
                const result = traverse(child);
                if (result) clone.appendChild(result);
                if (reachedLimit) break;
            }

            return clone;
        }

        return null;
    }

    const resultNode = traverse(container);
    const tempDiv = document.createElement("div");
    if (resultNode) tempDiv.appendChild(resultNode);
    return tempDiv.innerHTML;
}



export default function TemplatePreview({ channel, body = "", subject = "", onClose }) {
    const MAX_CHARS = 125;
    const [isExpanded, setIsExpanded] = useState(false);

    const shouldTruncate = body.length > MAX_CHARS;
    const displayHtml = shouldTruncate && !isExpanded
        ? truncateHtmlPreserveTags(body, MAX_CHARS)
        : body;

    const toggleExpand = () => setIsExpanded(!isExpanded);

    const lcChannel = channel?.toLowerCase?.() || "email";

    if (lcChannel === "whatsapp") {
        return (
            <div className="modal-overlay" >
                <div className="wa-preview">
                    <div className="wa-head-sty" onClick={onClose}><img src={rightArrowIcon} alt="Close" className="wa-back-img" /></div>
                    <div className="wa-bubble">
                        <div
                            className="wa-bubble-content"
                            dangerouslySetInnerHTML={{ __html: displayHtml }}
                            // onClick={!isExpanded ? toggleExpand : undefined}
                            onClick={(e) => {
                                if (
                                    !isExpanded &&
                                    e.target.matches('[data-readmore="true"]')
                                ) {
                                    toggleExpand();
                                }
                            }}
                        />
                    </div>
                </div>
            </div>

        );
    }

    if (lcChannel === "sms") {
        return (
            <div className="modal-overlay">
                <div className="sms-preview">
                    <div className="wa-head-sty" onClick={onClose}><img src={rightArrowIcon} alt="Close" className="wa-back-img" /></div>
                    <div
                        className="sms-bubble"
                        dangerouslySetInnerHTML={{ __html: displayHtml }}
                        onClick={(e) => {
                            if (
                                !isExpanded &&
                                e.target.matches('[data-readmore="true"]')
                            ) {
                                toggleExpand();
                            }
                        }}
                    />
                </div>
            </div>

        );
    }

    return (
        <div className="modal-overlay">
            <div className="mail-preview">
                <div className="sms-head-sty" onClick={onClose}><img src={rightArrowIcon} alt="Close" className="wa-back-img" /></div>
                <div style={{ fontSize: 18, fontWeight: 500, paddingLeft: 5 }}>
                    {subject || ""}
                </div>
                <section style={{ paddingTop: 5, color: '#000' }} dangerouslySetInnerHTML={{ __html: body }} />
            </div>
        </div>

    );
}
